var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadManagerMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#FF4E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1208 20H30.2044V24.5652H51.1208V20ZM30.8581 20.6522V23.9131L30.8594 23.9131V20.6522L50.4671 20.6522H30.8581ZM60.2754 79.3478L52.105 63.0434L52.1053 63.0434L60.2757 79.3478L60.2754 79.3478ZM25.9599 76.0869L25.9596 76.0869L24.3255 79.3478L24.3258 79.3478L25.9599 76.0869ZM50.4709 27.1736L57.0072 30.4345V63.0434L57.0076 63.0434V30.4345L50.4712 27.1736H30.8621L30.8621 27.1736H50.4709ZM27.5936 32.4562L31.6462 30.4345H31.6465L27.594 32.4562V43.478L53.7391 43.478H27.5936V32.4562ZM27.5936 59.7825V46.7389L27.594 46.7389V59.7825L27.5936 59.7825ZM32.4962 63.0434L30.8621 66.3043L30.8618 66.3043L32.4959 63.0434L32.4962 63.0434ZM27.5936 72.826L29.2277 69.5652L29.228 69.5652L27.594 72.826L27.5936 72.826ZM23.6721 63.6955H28.1704L20 80H24.7297L26.3638 76.7391H54.9695L56.6036 80H61.3333L53.1629 63.6955H57.6612V30.0314L50.6255 26.5214H30.7078L23.6721 30.0314V63.6955ZM28.2476 42.8259V32.8593L31.8008 31.0866H49.5325L53.0857 32.8593V42.8259H28.2476ZM28.2476 59.1303V47.3911H53.0857V59.1303H28.2476ZM48.4331 63.6955L49.4136 65.6521H31.9197L32.9002 63.6955H48.4331ZM52.6818 72.1739H28.6516L29.632 70.2173H51.7013L52.6818 72.1739ZM30.8594 53.2613V56.5222L30.8581 56.5222V53.2613L30.8594 53.2613ZM34.7799 52.6091H30.2044V57.1744H34.7799V52.6091ZM47.2031 53.2613V56.5222L47.2018 56.5222V53.2613L47.2031 53.2613ZM51.1236 52.6091H46.5482V57.1744H51.1236V52.6091Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.666,
    y: 20,
    width: 4,
    height: 60,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 20,
    width: 4,
    height: 60,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadManagerMini);
export default __webpack_public_path__ + "static/media/load_manager_mini.eeec39ea58f092bbfaccfd50fda03d33.svg";
export { ForwardRef as ReactComponent };